import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AiReviewPage from "./AiReviewPage";
import { LocaleProvider } from "./locale";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element was not found");
}

const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
const Page = pathname === "/ai-review" ? AiReviewPage : App;

createRoot(root).render(
  <StrictMode>
    <LocaleProvider>
      <Page />
    </LocaleProvider>
  </StrictMode>,
);
